import React, { FC, HTMLAttributes, ReactNode, useEffect, useRef } from "react";
import { twMerge } from "tailwind-merge";

interface IModalProps {
  visible: boolean;
  onClose?: () => void;
  marginBottom?: number;
  autoClose: boolean; // auto close when click in content
  children?: ReactNode;
  blurBackground?: boolean;
  className?: HTMLAttributes<HTMLDivElement>["className"];
}

const ModalBottom: FC<IModalProps> = ({
  visible,
  onClose,
  autoClose,
  marginBottom = 0,
  blurBackground = false,
  children,
  className,
}) => {
  const overlayRef = useRef<HTMLDivElement>(null);
  const modalRef = useRef<HTMLDivElement>(null);

  const handleOpenModal = () => {
    document.body.style.overflow = "hidden";
    setTimeout(() => {
      modalRef?.current?.classList.remove("opacity-0");
      modalRef.current?.classList.remove("translate-y-full");
    }, 50);
  };

  const handleCloseModal = () => {
    modalRef.current?.classList.add("translate-y-full");
    setTimeout(() => {
      modalRef?.current?.classList.add("opacity-0");
    }, 200);
    setTimeout(() => {
      document.body.style.overflow = "auto";
    }, 300);
    onClose && onClose();
  };

  useEffect(() => {
    if (visible) {
      handleOpenModal();
    } else {
      handleCloseModal();
    }
  }, [visible]);

  return (
    <div
      id="modal_overlay"
      ref={overlayRef}
      className={`fixed inset-0 z-20 top-0 bottom-${marginBottom} left-0 right-0 ${blurBackground && "bg-gray-50"} bg-opacity-70 ${visible ? "flex" : "hidden"}`}
      onClick={() => onClose && onClose()}
    >
      <div
        id="modal"
        ref={modalRef}
        className="flex flex-col fixed w-full h-full transform translate-y-full transition-transform duration-500"
      >
        <div
          className={twMerge(
            `bg-white p-8 border-gray-200 border-2 mt-auto rounded-t-3xl mb-${marginBottom}`,
            className
          )}
          onClick={(e) => !autoClose && e.stopPropagation()}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default ModalBottom;
